module.exports = __webpack_public_path__ + "static/img/living.bce532e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/living.png
// module id = 3Gk8
// module chunks = 0